module.exports = __webpack_public_path__ + "json/buildings-2.json?7361bd7c1dd0ec4c9a49517a06e84e12";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-2.json
// module id = 1721
// module chunks = 3